import React, { useContext, useMemo } from 'react';
import { SimpleContent } from '@stereoagency/ui';
import { LinesContext } from '@/components/LinesContext';
import { parseHtml } from '@/utils';

type Props = {
  data?: {
    title?: string
    content?: string
  } | null
};

export default function NvisoSimpleContent({ data }: Props) {
  const { enableLines } = useContext(LinesContext);
  const children = useMemo(() => (data?.content ? parseHtml(data.content) : null), [data]);
  if (!data?.title || !children) return null;

  return (
    <SimpleContent enableLines={enableLines} title={data.title}>{children}</SimpleContent>
  );
}
